






























































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { State, Action, namespace } from "vuex-class";
const accountManage = namespace("accountManage");
import { getStore } from "../../../../../utils/utils";
import { PasswaordContent } from "@/components";
const reimbursement = namespace("reimbursement");
import md5 from "md5";
@Component({
  name: "prepayment",
  components: {
    PasswaordContent,
  },
})
export default class prepayment extends Vue {
  @accountManage.Action bankListFN: any;
  @accountManage.State bankList: any;
  @reimbursement.Action queryPay;
  @reimbursement.Action queryAllPrePay; // 全部提前结清试算
  @reimbursement.State allPrePayObj; // 全部提前结清试算data

  //   @Prop() type // allSquare:全部结清
  @Prop() data; //  billNo  loanAmt  reduAmt  billMonth
  showPicker: boolean = false;
  showBankList: Array<string> = [];
  praData: any = {}; // 参数
  //   totalAmount: any = 0 //总金额
  //   vShow: any = false // 修改金额 展示与否
  errorMessage: any = ""; // 错误信息
  componentShow: any = false; // 付款框展示控制
  accNo: any = ""; // 银行卡号

  created() {
    this.bankListFN({
      custId: getStore("userInfo")
        ? JSON.parse(getStore("userInfo")).custId
        : "",
    });
    this.queryAllPrePay({
      custId: getStore("userInfo")
        ? JSON.parse(getStore("userInfo")).custId
        : "",
    });
    // this.totalAmount = this.data.loanAmt - this.data.reduAmt // 金额-减免手续费
  }
  // 修改金额点击
  //   updateClick(val, type) {
  //     this.vShow = type
  //     if (val == 'all') {
  //       this.totalAmount = this.$money(this.data.loanAmt)
  //     }
  //   }
  //   checkTotalAmount() {
  //     if (this.totalAmount != '' && Number(this.totalAmount) < 1) {
  //       this.errorMessage = '还款金额不能低于1元'
  //       return false
  //     } else if (Number(this.totalAmount) > this.data.loanAmt) {
  //       this.errorMessage = `最高可还款${this.data.loanAmt}元`
  //       return false
  //     } else if (this.totalAmount == '') {
  //   this.errorMessage = '请输入还款金额'
  // }else {
  //       this.errorMessage = ''
  //       return true
  //     }
  //   }

  onCancel() {
    this.componentShow = false;
  }
  handleShowPicker() {
    this.showPicker = true;

    this.$nextTick(() => {
      const ele: any = this.$refs.picker;
      ele.setValues([this.accNo]);
    });
  }

  @Watch("bankList", { immediate: true })
  onchanged(val: any) {
    this.showBankList = [];
    for (var i = 0, len = val.length; i < len; i++) {
      let accNo = val[i]["accNo"];
      let strNum = accNo.substr(accNo.length - 4);
      let newAccNo = `${strNum}(${val[i]["bankName"]})`;
      val[i]["showAccNo"] = newAccNo;
      this.showBankList.push(val[i]["showAccNo"]);
      if (val[i]["isDefault"] == "01") {
        this.accNo = val[i]["showAccNo"];
      }
    }
  }

  onConfirm(value) {
    this.showPicker = false;
    this.accNo = value;
  }
  //确认按钮
  buttonClick(type) {
    this.componentShow = true;
  }

  // 处理银行卡号转换
  changeAccNo(str: string, data: Array<string>) {
    let strSplit = str.split("(")[0];
    let newStr = "";
    for (var i = 0, len = data.length; i < len; i++) {
      if (data[i]["accNo"].indexOf(strSplit) !== -1) {
        newStr = data[i]["accNo"];
      }
    }
    return newStr;
  }

  //确认还款方法
  confirmClick(val) {
    if (val && val.length == 6) {
      let accNo1 = this.changeAccNo(this.accNo, this.bankList);
      let params = {
        retuKind: 5,
        accNo: accNo1, // 银行卡号
        amt: this.allPrePayObj.samt,
        billNo: this.data.billNo, // 账单号
        custId: JSON.parse(getStore("userInfo")).custId || "", // 客户编号
        passWord: md5(val), //支付密码
      };
      this.$toast.loading({
        message: "正在支付",
        duration: 0,
        forbidClick: true,
      });

      this.queryPay(params).then((res) => {
        if (res["code"] == 200) {
          this.$toast.clear();
          this.onCancel();
          this.$router.replace({
            path: "/reimbursementConfirm/paymentResult",
            query: {
              status: "success",
              text: res.msg,
              billMonth: res.data.billMonth,
            },
          });
        } else if (res["code"] == 300) {
          this.$toast.clear();
          this.onCancel();
          this.$router.replace({
            path: "/reimbursementConfirm/paymentResult",
            query: {
              status: "paying",
              text: res.msg,
              billMonth: res.data.billMonth,
            },
          });
        } else if (res["code"] == 400) {
          this.$toast.clear();
          this.onCancel();
          this.$toast.fail(res.msg);
        } else {
          this.$toast.clear();
          this.onCancel();
          this.$router.replace({
            path: "/reimbursementConfirm/paymentResult",
            query: {
              status: "error",
              text: res.msg,
              billMonth: res.data.billMonth,
            },
          });
        }
      });
    }
  }
}
